/* eslint-disable default-param-last */
import {
  CERTS_EXPORT_APPLY_FILTER,
  CERTS_EXPORT_COLUMNS_TO_EXPORT,
  CERTS_EXPORT_STATUS,
  GET_CERTS_DETAILS_FOR_EXPORT,
  SET_CERTS_EXPORT_IS_LOADING,
} from '../types';

const INITIAL_STATE = {
  applyFilter: false,
  columnsToExport: {},
  certsExportIsLoading: false,
  certsExportStatus: { exportStatus: '', timeStamp: 0 },
  certsDetailsAllCount: null,
};

const certsExportReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case CERTS_EXPORT_STATUS:
      return {
        ...state,
        certsExportStatus: action.payload,
      };

    case CERTS_EXPORT_APPLY_FILTER:
      return {
        ...state,
        applyFilter: action.payload,
      };

    case CERTS_EXPORT_COLUMNS_TO_EXPORT:
      return {
        ...state,
        columnsToExport: action.payload,
      };

    case GET_CERTS_DETAILS_FOR_EXPORT:
      return {
        ...state,
        certsDetailsAllCount: action.payload,
      };
    case SET_CERTS_EXPORT_IS_LOADING:
      return {
        ...state,
        certsExportIsLoading: action.payload,
      };

    default:
      return state;
  }
};

export default certsExportReducer;
